module.exports = __webpack_public_path__ + "static/media/1.20ad3bcd.png";